import { TypeEventService } from '../../../shared/services/type-event.service';
import { Inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

export class CagnottesListEventTypeResolver implements Resolve<any[]> {

  constructor(@Inject(TypeEventService) private service: TypeEventService) { }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> {
    return this.service.list();
  }
}
